import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericCRUDService } from '../../shared/services';
import { AprovacaoMassiva } from './AprovacaoMassiva';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AprovacoesMarcelinhoService extends GenericCRUDService {

    private workersUrl = `${environment.workersURL}/admin/users/aprovacao-massiva`;

    constructor(http: HttpClient) {
        super(http);
    }

    aprovar(aprovacaoMassiva: AprovacaoMassiva): Observable<AprovacaoMassiva> {
        return this.http.patch<AprovacaoMassiva>(this.workersUrl, aprovacaoMassiva);
    }
}
